import { diSanaReturnPs } from "@/app/utils/constants"
import DefaultLayout from "@/layouts/Default"
import InfoContainer from "../components/InfoContainer"
import RadioList from "../components/RadioList"

const ReturnP = () => {
  return (
    <DefaultLayout>
      <InfoContainer title="Return Policy">
        {diSanaReturnPs.map((r, i) => (
          <div key={i}>
            <RadioList detail={r} />
          </div>
        ))}
      </InfoContainer>
    </DefaultLayout>
  )
}

export default ReturnP